import { jsx as _jsx } from "react/jsx-runtime";
import { useScrollVisibility } from "@/hooks/useScrollVisibility";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { HOME_PAGE } from "@/settings/constant";
import { AnimatePresence, motion } from "framer-motion";
import { useRouter } from "next/router";
import useGNBMenu from "@/components/common/GNB/hooks/useGNBMenu";
import { appBarHeight } from "./AppBar";
import { HomeSwitch } from "./HomeSwitch";
const FLOATING_GAP = 20 // 앱바와의 간격
;
const floatingBottom = appBarHeight + FLOATING_GAP;
export const FloatingHomeSwitch = (param)=>{
    let { className  } = param;
    const router = useRouter();
    const { homeType , handleToggle  } = useGNBMenu();
    const isAtTop = useScrollVisibility({
        mode: "top",
        topThreshold: 10
    });
    const isHomePage = router.pathname === HOME_PAGE;
    const handleChange = (type)=>{
        mixpanelEvent("Home Type Toggle Clicked", {
            "Toggle Type": type === "teacher" ? "선생님" : "학생",
            Position: "AppBar"
        });
        handleToggle(type);
    };
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: isHomePage && isAtTop && /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                opacity: 0,
                y: 20
            },
            animate: {
                opacity: 1,
                y: 0
            },
            exit: {
                opacity: 0,
                y: 20
            },
            transition: {
                duration: 0.2,
                ease: "easeInOut"
            },
            style: {
                bottom: floatingBottom
            },
            className: cn("fixed left-1/2 z-50 -translate-x-1/2", "lg:hidden", className),
            children: /*#__PURE__*/ _jsx(HomeSwitch, {
                value: homeType,
                onChange: handleChange
            })
        })
    });
};
